import React, {Component} from 'react';
import {DropdownItem, DropdownMenu, DropdownToggle, Nav, NavItem, NavLink} from 'reactstrap';
import PropTypes from 'prop-types';

import {AppHeaderDropdown, AppSidebarToggler} from '@coreui/react';
import {Button,Icon} from 'semantic-ui-react'
import './Style.css'
import * as actionCreator from "../../store/Action";
import {connect} from "react-redux";
import parktag_logo from '../../assets/img/logos/parktag_logo.png';

const propTypes = {
  children: PropTypes.node,
};

const defaultProps = {};
const width = 600, height = 600
const left = (window.innerWidth / 2) - (width / 2)
const top = (window.innerHeight / 2) - (height / 2)


class ParkHeader extends Component {
  state = {
    select_tag:1
  };

  changeSystem = (type) => {
    this.props.systemChangeHandler(type)
  };

  checkPopup (type) {
    const check = setInterval(() => {
      const {popup} = this
      try {
        let search = popup.window.location.search

        if (search === '' || search === null || search === undefined) {
        } else {
          popup.window.close()


        }
      } catch (e) {
        console.log('social media error', e)
      }

      if (!popup || popup.closed || popup.closed === undefined) {
        clearInterval(check)
      }
    }, 1000)
  }

  render() {
    // eslint-disable-next-line
    const {children, ...attributes} = this.props;

    return (
      <React.Fragment>
        <AppSidebarToggler className="d-lg-none" display="md" mobile/>

        <h1 className={"logo-text"}><span style={{color: '#53bd52'}}>#</span>tags</h1>

        <Button animated className={this.props.system_changer === 1 ? "select-btn" : "unselect-btn"}>
          <Button.Content visible>
            <img src={parktag_logo} alt={"."} className={"logos"}/>&nbsp; ParkTags
          </Button.Content>
          <Button.Content hidden>
            <img src={parktag_logo} alt={"."} className={"logos"}/>&nbsp;
            <Icon name='arrow down' />
          </Button.Content>
        </Button>

        <Nav className="ml-auto" navbar>
          <AppHeaderDropdown direction="down">
            <DropdownToggle nav>
              <span style={{
                fontSize: '16px',
                color: '#585858',
                fontWeight: '600',
                marginRight:'10px'
              }}>{this.props.usr_obj === undefined ? "Welcome admin" : "Welcome " + this.props.usr_obj.fullName}
                &nbsp;
                <i className="fa fa-caret-down"></i>
              </span>
              {/*<img src={usrProPic} className="img-avatar" alt="..."/>*/}
            </DropdownToggle>
            <DropdownMenu right style={{right: 'auto'}}>
              <DropdownItem onClick={e => this.props.onLogout(e)}><i className="fa fa-lock"/> Logout</DropdownItem>
            </DropdownMenu>
          </AppHeaderDropdown>
        </Nav>
      </React.Fragment>
    );
  }
}

ParkHeader.propTypes = propTypes;
ParkHeader.defaultProps = defaultProps;

const mapStateToProps = (state) => ({
  system_changer: state.systemChangeReducer.system_changer,
  usr_obj: state.userReducer.user,
});

const mapDispatchToProps = (dispatch) => {
  return {
    systemChangeHandler: (data) => dispatch(actionCreator.systemChangeHandler(data)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(ParkHeader);
